import { Component, OnInit } from '@angular/core';

declare function initPlugins();

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styles: []
})
export class PagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    initPlugins();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/pages/pages.component.ts